import { FC } from 'react'

import Button from 'components/forms/Button'
import imageResize, { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'
import Link from 'next/link'
import classNames from 'classnames'
import Strings from 'project/localisation'
import { Constants } from 'common/utils'
import { Tenant } from 'common/tenant'

type Props = {
  tenant?: Tenant
}

const ContactUsCard: FC<Props> = ({ tenant = Tenant.UK }) => {
  const au = tenant === Tenant.AU
  const size = useWindowSize()
  return (
    <div className='card overflow-hidden position-relative'>
      <div className='d-flex flex-column flex-lg-row h-100 justify-content-end'>
        <div className='ps-4 ps-lg-12 pt-11 pb-lg-3 d-flex flex-column position-lg-absolute left-0'>
          <h2 className='fw-semibold lh-114 fs-fluid-40-48'>
            {au ? (
              <>
                Our Sydney <br /> CBD address:
              </>
            ) : (
              <>
                Our Central <br /> London address:
              </>
            )}
          </h2>
          <span className='fs-fluid-18-24 fw-semibold pt-2 pb-6 lh-140'>
            {au
              ? Constants.companyInformation.address2Au
              : Constants.companyInformation.address2}
            ,
            <br />
            {au
              ? Constants.companyInformation.cityAu
              : Constants.companyInformation.city}
            ,
            <br />
            {au
              ? Constants.companyInformation.postal_codeAu
              : Constants.companyInformation.postal_code}
            <br />
            <a
              className={classNames(
                'text-link-pink',
                size.isMdOrLower ? 'text-underline' : '',
              )}
              href={
                au
                  ? 'https://www.google.com.au/maps/search/?api=1&query=10%2F387+George+Street%2C+Sydney+NSW+2000'
                  : 'https://g.page/HoxtonMix?share'
              }
              target='_blank'
              rel={'noopener noreferrer'}
            >
              {Strings.directions}
            </a>
            {/*always 22px*/}
          </span>
          <Link href={au ? '/au/contact-us' : '/contact-us'}>
            <Button
              theme='secondary'
              className='align-self-lg-start w-lg-auto w-100 mt-4'
            >
              Contact Us
            </Button>
          </Link>
        </div>
        {size.isLgOrHigher ? (
          <div
            className='d-flex align-items-end'
            style={{
              width: '88%',
            }}
          >
            <img
              {...generateSrcSet(
                '/images/new/robot-upperhalf-half-head.png',
                590,
                730,
              )}
              alt='robot upper head'
              className='img-fluid'
              height={730}
              width={590}
              loading='lazy'
            />
          </div>
        ) : (
          <img
            {...generateSrcSet('/images/new/robot-head-small.png', 361, 209)}
            alt='robot upper head'
            className='w-100 h-auto rounded-bottom-img'
            height={209}
            width={361}
            loading='lazy'
          />
        )}
      </div>
    </div>
  )
}

export default ContactUsCard
